<div class="overlay">
  <div class="content">
    <div class="header-container">
      <div class="header-inner-container">
        <div class="rv-flex">
          <h5 class="rv-title-05">You have unsaved changes</h5>
          <button
            rivButton
            [variant]="'ghost'"
            [size]="'large'"
            class="close"
            title="Close"
            [rivTooltip]="'Close'"
            type="button"
            (click)="$event.preventDefault(); cancel()"
            [icon]="'X'"
          ></button>
        </div>
      </div>
    </div>
    <div class="body">
      <div class="rv-rows medium outer">
        <p>
          You have unsaved changes on this page. Are you sure you want to leave
          this page?
        </p>
      </div>
    </div>
    <div class="rv-rows large outer footer">
      <div class="rv-button-set">
        <button
          rivButton
          [variant]="'basic'"
          [size]="'medium'"
          (click)="cancel()"
        >
          Continue editing
        </button>
        <button
          rivButton
          [variant]="'primary'"
          [size]="'medium'"
          (click)="confirm()"
        >
          Yes, leave
        </button>
      </div>
    </div>
  </div>
</div>
